<template>
  <modal name="newTermsDetailPopup" :adaptive="true" @before-open="beforeOpen" @opened="opened">
    <div id="newTermsDetailPopup" class="mobile-popup">
      <div class="popup-header talk re-style">
        <header class="pad_0">
          <h1><a class="logo"></a></h1>
        </header>
        <p class="page-header__big-text mar_b0">
          중고폰 판매 계약 및 <br> 개인정보활용 동의서
        </p>
      </div>
      <div class="popup-body">
        <div class="agree-box">
          <h4 class="title2">제 1조 (목적)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                민팃의 서비스를 이용해 주셔서 감사합니다. 본 약관은 다양한 민팃 서비스의 이용과 관련하여 민팃 서비스를 제공하는 민팃 주식회사(이하 “회사”)와 이용자간의 관계를 설명하며, 아울러 “회사”의 서비스 이용에 도움이 될 수 있는 유익한 정보를 포함하고 있습니다. <br> <br>
                민팃의 서비스를 이용하거나 민팃 서비스 회원으로 가입하실 경우 여러분은 본 약관 및 관련 운영 정책을 확인하거나 동의하게 되므로, 잠시 시간을 내시어 주의 깊게 살펴봐 주시기 바랍니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 2조 (정의)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ① “이용자”라 함은 “회사”의 서비스에 접속하여 본 약관에 따라 “회사”가 제공하는 콘텐츠를 이용하는 “회원” 및 “비회원”을 말합니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회원”이라 함은 “회사”가 제공하는 서비스를 받기 위하여 “회사”와 이용계약을 체결하고 “이용자” 아이디(ID)를 부여 받은 자를 말합니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “비회원”이라 함은 “회원”에 가입하지 않고 서비스를 이용하는 자를 말합니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ “고객”이라 함은 “회사”의 “민팃 Home”을 통해 “단말기 매매계약”을 체결하는 “이용자”를 말합니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑤ "아이디(ID)"라 함은 “회원”의 식별과 "서비스" 이용을 위하여 “회원”이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 의미합니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑥ "비밀번호"라 함은 “회원”이 부여 받은 아이디와 일치되는 “회원”임을 확인하고 비밀보호를 위해 “회원” 자신이 정한 문자 또는 숫자의 조합을 의미합니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑦ "게시물"이라 함은 “이용자”가 "서비스"를 이용함에 있어 서비스상에 게시한 부호·문자·음성·음향·화상·동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑧ "해지"라 함은 “회사” 또는 “회원”이 이용계약을 해약하는 것을 말합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>⑨ “서비스”라 함은 “회사”가 “웹사이트” 및 “모바일앱” 그리고 “ATM기기”를 통해 “이용자”에게 제공하는 각종 “서비스”를 의미합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑩ “즉시매입서비스”라 함은, “민팃 Home”에서 “고객”이 판매 동의를 완료한 “단말기”를 매입하는 서비스를 의미합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑪ “단말기”라 함은 “고객”이 “민팃 Home”을 통해 “회사”에게 매도하는 중고 IT기기를 말합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑫ “단말기 매매계약”이라 함은, “고객”이 “민팃 Home”을 통해 “회사”에게 “고객” 소유의 “단말기”를 양도하고 “회사”는 “고객”으로부터 “단말기”를 양도받은 후 “고객”에게 “단말기”에 대한 매매대금을 지급하는 계약을 말합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑬ “민팃 Home”이란 택배 방식으로 단말기의 성능 평가, 데이터 삭제, 시세 조회, 매매 계약 등을 수행하고, “고객”에게 관련 정보와 서비스를 제공하는 “민팃”의 서비스를 말합니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 3 조 (약관의 게시와 개정)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>① “회사”는 이 약관의 내용을 “회원”들이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.</p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 관계법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 서비스 초기화면에 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ 전항에 따라 시행일 이후에 “회원”이 서비스를 이용하는 경우에는 개정약관에 동의한 것으로 간주합니다. “회원”은 변경된 약관에 동의하지 않을 경우 이용계약을 해지할 수 있습니다. 변경된 약관에 대한 정보를 알지 못해 발생하는 피해는 “회사”가 책임을 지지 않습니다.</p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 4 조 (약관의 해석)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                이 약관에서 정하지 아니한 사항이나 해석에 대해서는 관계법령 또는 상관례에 따릅니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 5 조 (서비스 이용계약 체결)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① 이용계약은 “회원”이 되고자 하는 자(이하 "가입신청자")가 약관의 내용에 대하여 동의를 한 다음 “회원”가입신청을 하고 “회사”가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회원”으로 가입하여 본 서비스를 이용하고자 하는 “이용자”는 “회사”에서 요청하는 정보(이름, 생년월일, 연락처 등)을 제공하며, 단 “회원”이 제공한 정보는 개인정보보호규정에 따라 관리됩니다. “회사”에서 요청하는 정보의 자세한 내용은 개인정보처리방침의 개인정보의 수집 항목에서 확인할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”에서는 서비스를 이용하는 “이용자”에 따라 서비스 메뉴 등의 이용에 차등을 둘 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ “회사”는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, “회사”는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
              </p>
              <ul class="list__item-sub">
                <li>
                  <p>
                    <i>1.</i> 실명이 아니거나 타인의 명의를 이용한 경우
                  </p>
                  <p>
                    <i>2.</i> 허위의 정보를 기재하거나, “회사”가 제시하는 내용을 기재하지 않은 경우
                  </p>
                  <p>
                    <i>3.</i> 형법에서 규정한 범죄 행위의 목적으로 본 서비스를 이용하고자 하는 경우
                  </p>
                  <p>
                    <i>4.</i> 14세 미만 아동이 법정대리인(부모 등)의 동의를 얻지 아니한 경우
                  </p>
                  <p>
                    <i>5.</i> 기타 현행 법령에 위배되는 목적으로 본 서비스를 이용하고자 하는 경우
                  </p>
                </li>
              </ul>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑤ “회사”는 “회원”의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑥ “회원”가입을 승낙하지 아니하거나 유보한 경우, “회사”는 이를 가입신청자에게 알리도록 합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑦ “회사”는 서비스관련 설비의 여유가 없거나 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑧ 이용계약의 성립 시기는 “회사”가 가입 완료를 신청절차 상에서 표시한 시점으로 합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑨ “단말기”를 판매하려는 “이용자”는 다음 각 호에 해당하는 사항을 준수해야 하며, 이를 위반함으로써 발생하는 손해 및 민형사상 분쟁에 대해 책임이 있습니다.
              </p>
              <ul class="list__item-sub">
                <li>
                  <p>
                    <i>1.</i> “단말기 매매계약”은 “이용자”가 “회사”에서 제공하는 “민팃 Home” 서비스 화면을 통해 본 약관 및 기타 “민팃 Home”에서 요청하는 동의 사항에 관한 동의를 완료한 경우 즉시 체결됩니다.
                  </p>
                  <p>
                    <i>2.</i> “단말기 매매계약”을 체결함에 있어서 “회사”는 “이용자”에게 실명확인 및 본인인증을 요청할 수 있습니다.
                  </p>
                </li>
              </ul>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 6 조 (회원정보의 변경)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “회원”은 마이페이지를 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회원”은 “회원”가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 “회사”에 대하여 그 변경사항을 알려야 합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ 전항의 변경사항을 “회사”에 알리지 않아 발생한 불이익에 대하여 “회사”는 책임을 지지 않습니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 7 조 (개인정보보호 의무)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                “회사”는 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 “정보통신망법”)등 관계 법령이 정하는 바에 따라 “회원”의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 “회사”의 개인정보보호규정이 적용됩니다. 다만, “회사”의 공식 사이트 이외의 링크된 사이트에서는 “회사”의 개인정보보호규정이 적용되지 않습니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 8 조 (회원의 아이디 및 비밀번호의 관리에 대한 의무)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “회원”의 아이디와 비밀번호에 관한 관리책임은 “회원”에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 “회원”의 아이디가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나. “회사”의 운영자로 오인한 우려가 있는 경우, 해당 아이디의 이용을 제한 및 변경할 수 있습니다. 또한 “회원”은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 “회사”에 통지하고 “회사”의 안내에 따라야 합니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 9 조 (회원에 대한 통지)
          </h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “회사”가 “회원”에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 “회원”이 지정한 전자우편주소 등으로 할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 “회원” 전체에 대한 통지의 경우 5일 이상 “회사”의 게시판에 게시함으로써 제9조1항의 통지에 갈음할 수 있습니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 10 조 (회사의 의무)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “회사”는 개인정보보호법, 정보통신망법 등 관련 법령상의 개인정보보호규정에 따라 “단말기 매매계약” 체결 과정에서 획득한 “고객”의 개인정보와 “회사”의 서비스를 이용하는 “회원”의 개인정보를 보호합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”는 계속적이고 안정적인 서비스의 제공을 위하여 설비에 장애가 생길 때에는 지체 없이 이를 수리 또는 복구해야 합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ “회사”는 개인정보처리방침을 제정하여 “회원”에게 고지하여 설명하고, “회원”의 개인정보를 적법하게 수집ㆍ이용ㆍ제공하기 위하여 “회원”으로부터 별도로 개인정보 수집ㆍ이용ㆍ제공 등에 관한 동의를 받습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑤ “회사”는 “회원”이 안전하게 서비스를 이용할 수 있도록 “회원”이 동의한 목적과 범위 내에서만 개인정보를 수집ㆍ이용하며, 개인정보 보호 관련 법령에 따라 안전하게 관리합니다. “이용자” 및 “회원”에 대해 관련 개인정보를 안전하게 처리하기 위하여 기울이는 노력이나 기타 상세한 사항은 개인정보처리방침에서 확인하실 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑥ “회사”는 서비스이용과 관련하여 “회원”으로부터 제기된 의견이나 불만이 정당하다고 인정될 경우에는 이를 처리하여야 합니다. “회원”이 제기한 의견이나 불만사항에 대해서는 고객센터를 활용하거나 전자우편 등을 통하여 “회원”에게 처리과정 및 결과를 전달합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑦ “회사”는 “단말기 매매계약”이 성립한 시점 이후 “고객”이 지정한 계좌로 단말기 판매대금을 입금합니다. 단, “고객”이 수취계좌를 지정하지 않을 경우 “회사”는 적정한 단말기 판매대금을 정하여 “고객”의 연락처로 통보하고, “회사”가 “고객”에게 단말기 판매대금을 통보한 때로부터 7일 내에 “고객”의 이의제기가 없으면 판매대금액이 확정되며, 판매대금이 “고객”에게 지급될 때까지 지연 이자는 발생하지 아니합니다. 단, “고객”이 연락처를 변경한 경우 “고객”은 “회사”로 연락처 변경사실을 통보하여야 하며, 변경사실을 통보하지 않은 경우 단말기 판매대금 지급이 안될 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑧ “회사”는 “단말기 매매계약”에 따라 “고객”으로부터 “단말기”를 수령할 경우, 검증된 솔루션을 사용하여 “단말기”에 저장된 “고객”의 정보 등 데이터를 모두 삭제합니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 11 조 (이용자의 의무)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “이용자”는 개인정보보호법, 정보통신망법 등의 관계 법령을 준수하여야 하며, 이 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, “회사”가 통지하는 사항 등을 준수하여야 하고 기타 “회사”의 업무에 방해되는 행위를 하여서는 안 됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회원”은 주소, 연락처, 전자우편 등 이용계약 사항이 변경된 경우에 온라인상에서 이를 수정해야 합니다. 수정을 하지 않거나 수정 지연으로 발생되는 문제에 대한 책임은 “회원”에게 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회원”은 “회원”에게 부여된 아이디와 비밀번호를 직접 관리해야 합니다. “회원”의 관리 소홀로 발생하는 문제의 책임은 “회원”에게 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ “회사”는 만 14세 미만 아동의 개인정보를 수집하지 않으며, “회원”가입이 불가능합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑤ “회원”은 다음 행위를 하여서는 안 됩니다
              </p>
              <ul class="list__item-sub">
                <li>
                  <p>
                    <i>1.</i> 신청 또는 변경 시 허위내용의 등록
                  </p>
                  <p>
                    <i>2.</i> 타인의 정보도용
                  </p>
                  <p>
                    <i>3.</i> “회사”가 게시한 정보의 변경
                  </p>
                  <p>
                    <i>4.</i> “회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
                  </p>
                  <p>
                    <i>5.</i> “회사”와 기타 제3자의 저작권 등 지적재산권에 대한 침해
                  </p>
                  <p>
                    <i>6.</i> “회사” 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
                  </p>
                  <p>
                    <i>7.</i> 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위
                  </p>
                  <p>
                    <i>8.</i> “회사”의 동의 없이 영리를 목적으로 서비스를 사용하는 행위
                  </p>
                  <p>
                    <i>9.</i> “회사”의 승인을 받지 않고 다른 “이용자”의 개인정보를 수집 또는 저장하는 행위
                  </p>
                  <p>
                    <i>10.</i> 기타 불법적이거나 부당한 행위
                  </p>
                </li>
              </ul>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑥ “단말기”를 판매하려는 “고객”는 다음의 사항을 준수하여야 합니다.
              </p>
              <ul class="list__item-sub">
                <li>
                  <p>
                    <i>1.</i> “단말기”의 소유권 및 단말기 판매대금을 입금 받을 계좌의 소유는 모두 법적 문제가 없는 “고객” 본인 소유 이어야 합니다.
                  </p>
                  <p>
                    <i>2.</i> “고객”은 “단말기 매매계약”을 체결하면서 “단말기 매매계약”의 원활한 이행을 위하여 “회사”에 거래 대상인 “고객” 소유의 “단말기”와 관련한 모든 권리를 양도하여야 합니다.
                  </p>
                  <p>
                    <i>3.</i> “단말기 매매계약” 성립 후에도, “고객”은 “단말기” 분실등록” 등과 같이 “회사”로의 “단말기” 소유권 이전을 고의적으로 방해하는 일체의 행위를 할 수 없습니다.
                  </p>
                  <p>
                    <i>4.</i> “고객”은 “단말기” 매매 과정에서 “민팃 Home”의 매매 가격 산정을 위한 “단말기” 상태 파악을 고의적으로 방해하지 않아야 하며, “단말기”의 가치 범위를 벗어난 불량 “단말기”를 반복적으로 매수 요청을 하지 않아야 합니다.
                    본 항에서 “단말기”의 가치 범위를 벗어난 불량 ”단말기”란 비정품 부품으로 수리한 “단말기” 또는 제조사에서 허용하지 않은 “운영 체제”를 사용한 “단말기” 등으로서 “회사”가 단말기를 제3자에게 양도함에 있어서 장애가 있는 “단말기”를 뜻합니다.
                  </p>
                  <p>
                    <i>5.</i> “고객”이 본 항의 의무를 위반할 경우, “회사”는 “단말기 매매 계약”을 거부 또는 해제할 수 있고, “고객”은 그로써 발생하는 손해 및 민ㆍ형사상 분쟁에 대한 책임이 있습니다.
                  </p>
                </li>
              </ul>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 12 조 (서비스의 제공 등)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① 서비스 이용은 “회사”의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 운영을 원칙으로 합니다. 단, 시스템 정기점검, 증설 및 교체를 위해 “회사”가 정한 날이나 시간에 서비스를 일시 중단할 수 있으며, 예정되어 있는 작업으로 인한 서비스 일시 중단은 서비스 페이지를 통해 사전에 공지합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 긴급한 시스템 점검, 비상사태 등 부득이한 사유로 인하여 예고 없이 일시적으로 서비스를 중단할 수 있고 사후공지 할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”는 서비스를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 13 조 (서비스의 변경)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ①“회사”는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 “회사”의 정책 변화 또는 수준 높은 서비스의 제공을 위해 서비스의 일부 또는 전부를 수정, 중단, 변경, 삭제할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”는 서비스의 수정, 삭제 등의 변화로 인해 “회원”들에게 심각한 불이익이 발생할 수 있는 사항에 대해서는 내용을 사전에 공지합니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 14 조 (정보의 제공 및 광고의 게재)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “회사”는 “회원”이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 “회원”에게 제공할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 서비스의 운영과 관련하여 서비스 화면, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편 등을 수신한 “회원”은 수신거절을 “회사”에 할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”는 서비스에 게재되어 있거나 본 서비스를 통한 광고주의 판촉활동에 “회원”이 참여하거나 교신 또는 거래의 결과로 발생하는 모든 손실 또는 손해에 대해서는 책임을 지지 않습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ “회사”는 서비스 개선 및 “회원” 대상의 서비스 소개 등의 목적으로 “회원”의 동의 하에 추가적인 개인정보를 요구할 수 있습니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 15 조 (권리의 귀속)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① 서비스에 대한 저작권 및 지적재산권은 “회사”에 귀속됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 서비스와 관련하여 “회원”에게 “회사”가 정한 이용조건에 따라 아이디, 서비스 등을 이용할 수 있는 이용권만을 부여하며, “회원”은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”가 “고객”이 지정한 계좌에 단말기 판매대금을 입금한 때, “단말기”와 관련한 소유권 등 모든 권리는 “회사”에게 귀속됩니다. 단, “고객”이 수취계좌를 지정하지 않을 경우 “회사”는 적정한 단말기 판매대금을 정하여 “고객”의 연락처로 통보하며, “회사”가 “고객”에게 단말기 판매대금을 통보한 때로부터 7일 후(즉시매입서비스의 경우 계좌 정보 입력 통보 7일 후)에 해당”단말기”의 소유권이 “회사”에 귀속됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ 제3항에 따라 “단말기”의 소유권을 취득한 “회사”는 “단말기”를 양도한 “고객”의 별도 동의 없이도 “단말기”를 제3자에게 처분할 수 있습니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 16 조 (계약의 해지 및 해제)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “회원”은 언제든지 서비스초기화면의 마이페이지 메뉴를 통하여 이용계약 해지 신청을 할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회원”이 계약을 해지하는 경우, 현재 진행 중인 거래를 완료하거나 철회 또는 취소하여야 하며, 거래의 철회 또는 최소로 인한 불이익은 “회원” 본인이 부담하여야 합니다. 또한, “회원”이 “회사”에 대한 채무를 전부 이행하지 않으면 “회원”이 해당 채무를 전부 이행할 때까지 “회사”는 “회원”의 이용계약 해지를 제한할 수 있으며, “회원”이 이 약관과 관계 법령 등을 위반하여 이용이 정지된 경우 “회사”가 재발방지를 위하여 “회원”의 이용계약 해지를 제한할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”가 해지할 때에는 “회사”는 “회원”에게 해지일 15일 전까지 전자우편, 전화, 팩스 기타의 방법으로 해지 사유를 밝혀 해지 의사를 통지합니다. 거래의 안전을 위하여 “회사”는 동일인 소유로 확인되는 “회원” 아이디(ID)에 대하여 일괄 해지 의사를 통지할 수 있습니다. 이용계약은 “회사”가 “회원”에게 해지의사를 밝히고 15일이 경과한 시점에 종료됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ “회원”의 의사로 해지한 후 “회원” 재가입, 임의 해지 등을 반복적으로 행하여 “회사”가 제공하는 각종 이벤트 혜택 등 경제적 이익을 편법으로 수취하거나 이 과정에서 명의를 무단으로 사용하는 등 편법과 불법행위를 하는 것을 차단하고자 “회사”는 “회원”에게 이용 계약이 종료된 후라도 해당 “회원”의 재가입 제한 기간을 운영하거나 도는 이용 신청을 승낙하지 않을 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑤ “회사”는 다음 각 호의 사유가 발생한 경우 “단말기 매매계약”을 해제할 수 있습니다.
              </p>
              <ul class="list__item-sub">
                <li>
                  <p>
                    <i>1.</i> “단말기”의 최종 검수 과정에서 “단말기”의 상태가 매매하기 위한 가치의 범위를 벗어났다고 판단되는 경우
                  </p>
                  <p>
                    <i>2.</i> “고객”이 본 약관 제11조의 의무를 위반함으로써 “단말기 매매계약”의 목적을 달성할 수 없다고 인정되는 경우
                  </p>
                </li>
              </ul>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑥ “고객”은 “단말기 매매계약”이 성립한 때로부터 7일 이내에 계약을 해제할 수 있습니다. 다만, 7일 이내라도 “회사”가 판매대금을 지급한 경우에는 해제할 수 없습니다.
              </p>
              <ul class="list__item-sub">
                <li>
                  <p>
                    <i>1.</i> “단말기 매매계약”이 해제될 경우, “고객”으로부터 “단말기”를 양도받은 “회사”는 “고객”의 부담으로 “고객”에게 “단말기”를 반환하여야 합니다.
                  </p>
                  <p>
                    <i>2.</i> 다만, “회사”는 다음과 같은 불가피한 경우에 한해 “고객”이 “회사”에게 인도한 “단말기”와 사양 및 품질 상태가 동일한 “단말기”로 반환할 수 있습니다.
                  </p>
                  <ul class="list__item-sub">
                    <li>
                      <p>
                        <i>가.</i> “고객”이 “회사”에게 판매한 “단말기”가 이미 제3자에게 판매되어 반환하기 어려운 경우
                      </p>
                      <p>
                        <i>나.</i>“고객”이 “회사”에게 판매한 "단말기"가 “회사”의 유통 및 검수 등 일련의 과정에서 파손되거나 유실된 경우
                      </p>
                      <p>
                        <i>다.</i>“고객”이 “회사”에게 판매한 “단말기”가 수사기관 등의 법적 요청에 따라 해당 기관에 인도한 경우(이 경우 고객의 과실이 없는 경우에 한함)
                      </p>
                      <p>
                        <i>라.</i>기타 상기 사례와 유사하여 고객이 판매한 "단말기" 자체를 반환하는 것이 불가피한 경우 등
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 17 조 (이용제한 등)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                “회사”는 “회원”이 약관의 의무를 위반 하거나 또는 아래 각 항에 해당될 경우 사전통보 없이 서비스 이용을 제한할 수 있습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                1. 서비스의 정상적인 운영을 방해한 경우
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                2. 주민등록법을 위반한 명의도용 및 결제도용, 저작권법 및 컴퓨터프로그램보호법을 위반한 불법프로그램의 제공 및 운영 방해, 정보통신망법을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속 권한 초과 행위 등과 같이 관련법을 위반한 경우
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                3. 방송통신심의위원회 등 관련 공공기관의 시정 요구가 있을 경우
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                4. 청소년보호법 등 관계 법령에 금지되어 있는 정보를 전송 또는 게시했을 경우
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                5. 서비스에 위해를 가하거나 고의로 방해한 경우
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                6. 본 약관을 포함하여 기타 “회사”가 정한 제반 규정 및 이용 조건을 위반한 경우
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 18 조 (면책조항 및 손해배상)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① “회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② “회사”는 “회원”의 귀책사유로 인한 서비스 이용의 장애 또는 손해에 대하여 책임을 지지 않습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ③ “회사”는 “회원”이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ④ “회사”는 “회원” 간 또는 “회원”과 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑤ “회사”는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다. 또한 무료서비스 이용과 관련하여 “회원”에게 발생한 어떠한 손해에 대해서도 책임을 지지 않습니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑥ “회사”가 개별서비스 제공자와 제휴 협정을 맺고 “회원”에게 개별서비스를 제공함에 있어 “회원”이 개별서비스 이용약관에 동의를 한 뒤 개별서비스 제공자의 귀책사유로 인해 손해가 발생한 경우 개별서비스 제공자가 책임을 집니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑦ “회사”는 기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우 책임이 면제됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑧ “회사”는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ⑨ “회사”가 본 약관 제10조 제8항에 따라 “고객”으로부터 “단말기”를 수령하여 “단말기” 내의 데이터를 모두 삭제한 경우, “고객”이 추후 본 약관 제16조 제 6항에 따라 “단말기 매매계약”을 해제한 후 “회사”에 대하여 “단말기”의 반환을 요청할 때에도 “고객”은 “단말기” 내의 데이터가 “단말기 매매계약” 당시의 상태로 복구되는 것이 불가능하다는 점을 충분히 이해하고 동의하며, “회사”는 이와 관련한 책임을 부담하지 아니합니다.
              </p>
            </li>
          </ol>
        </div>
        <div class="agree-box">
          <h4 class="title2">제 19 조 (분쟁조정)</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                ① 이 약관에 명시되어 있지 않은 사항이 관계법령에 규정되어 있을 경우 그 규정에 따릅니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                ② 서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 법령에 정한 절차에 따른 법원을 관할 법원으로 합니다.
              </p>
            </li>
            <li class="list__item no-bullet">
              <br>
              <p>
                <b>
                  본 약관은 2025년 8월 18일부터 적용됩니다.
                </b>
              </p>
            </li>
          </ol>
        </div>
      </div>
      <!-- 하단 버튼 -->
      <div class="popup-footer">
        <div id="regBtnDiv" class="ui-buttons">
          <ul class="ui-buttons__list">
            <li class="ui-buttons__item">
              <button type="button" class="ui-button ui-basic-button" @click="close">
                확인
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NewTermsDetailPopup',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    beforeOpen (e) {
    },
    opened () {
      document.body.classList.add('modal-open')
      $('.mscroll').mCustomScrollbar({
        theme: 'dark-thick',
        scrollInertia: 600
      })
    },
    close () {
      this.$modal.hide('newTermsDetailPopup')
      document.body.classList.remove('modal-open')
    }
  }
}
</script>

<style>
body.modal-open {
  overflow: hidden;
}
</style>
<style scoped>
.mobile-popup {
  position: fixed;
  top: 0;
  left: 50%;
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  z-index: 1001;
}

/* 헤더 */
.popup-header {
  position: relative;
  padding: 20px 16px 20px;
  background-color: #fff;
}

.popup-title {
  display: block;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  line-height: 1.5;
  word-break: keep-all;
}

.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 25px;
  height: 25px;
  border: none;
  border-radius: 50%;
  background-color: #00C4B4;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  padding: 0;
}

/* 본문 */
.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  -webkit-overflow-scrolling: touch;
  word-break: break-all; /* 단어 중간이라도 줄바꿈 가능 */
  white-space: normal;   /* 기본 줄바꿈 허용 */
}

.clause-title {
  font-weight: bold;
  margin-top: 12px;
  font-size: 15px;
}

/* 하단 버튼 */
.popup-footer {
  padding: 16px;
  background: white;
}

.popup-confirm {
  width: 100%;
  height: 53px;
  padding: 14px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  background-color: #00C4B4;
  color: white;
  border-radius: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/home/components/NewTermsDetailPopup.vue